import { render, staticRenderFns } from "./PsPatientPaymentHistoryItem.vue?vue&type=template&id=5ddc7fa0&scoped=true&"
import script from "./PsPatientPaymentHistoryItem.vue?vue&type=script&lang=js&"
export * from "./PsPatientPaymentHistoryItem.vue?vue&type=script&lang=js&"
import style0 from "./PsPatientPaymentHistoryItem.vue?vue&type=style&index=0&id=5ddc7fa0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ddc7fa0",
  null
  
)

export default component.exports